import { Button } from '@dtx-company/design-system/src'
import { FC } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

export const ChangePaymentMethodButton: FC<{
  onShowExistingCreditCardChange: (value: boolean) => void
}> = ({ onShowExistingCreditCardChange }) => {
  return (
    <Button
      type="button"
      color="tertiary"
      variant={'text'}
      onClick={() => {
        onShowExistingCreditCardChange(false)
      }}
      endIcon={ExpandMoreIcon}
    >
      Change payment
    </Button>
  )
}
